import CodeInput from '@/core/components/inputs/CodeInput/CodeInput';

export default CodeInput;
